import { ShipApi } from "../../Types/Generated/LogbookApi/ShipApi"
import { entity } from "./Connection"

export const NoteAttachmentEntity = entity("NoteAttachment", {
  fetch: (client, { shipId, noteId }) => {
    if (shipId === undefined || noteId !== 0) {
      return Promise.reject(new Error("Ship attachment fetch requires shipId and noteId 0"));
    }
    return new ShipApi(client).ships.attachments({ params: { shipId } }).call().then((response) => ({
      entities: { NoteAttachment: response.attachments },
      authoritative: { NoteAttachment: { shipId, noteId: 0 } },
    }));
  },
});
